module.exports = "data:image/gif;base64,R0lGODlhJAAJAIABAAAAAP///yH5BAEAAAEALAAAAAAkAAkAAAIujAOHquD/GjORpomga5fXOmkeo20QlnWpWraqdIio986rHW84qeP9zgHWgBRFAQA7"